
export default function MissionVisionQuality() {
  const values = [
    {
      icon: 'ri-rocket-line',
      title: 'Our Mission',
      description: 'To empower beauty and healthcare professionals with premium products that elevate their services and enhance client satisfaction. We strive to be the preferred partner for businesses seeking excellence in spa, salon, and medical supplies.'
    },
    {
      icon: 'ri-eye-line',
      title: 'Our Vision',
      description: 'To become a global leader in the distribution of spa, salon, and medical products, recognized for our commitment to quality, innovation, and customer success. We envision a future where every professional has access to world-class products.'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Quality Assurance',
      description: 'Quality is at the heart of everything we do. We meticulously select products from trusted manufacturers, ensuring they meet stringent international standards. Our rigorous quality control processes guarantee that every product delivers exceptional performance and reliability.'
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-br from-gray-50 to-teal-50">
      <div className="container mx-auto px-4 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            Our Core <span className="text-teal-600">Values</span>
          </h2>
          <p className="text-base text-gray-600 max-w-2xl mx-auto">
            Driven by excellence, guided by integrity, and committed to your success
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {values.map((value, index) => (
            <div
              key={index}
              className="bg-white rounded-lg p-8 shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-2"
            >
              <div className="w-16 h-16 flex items-center justify-center bg-teal-600 rounded-full mb-6 mx-auto">
                <i className={`${value.icon} text-white text-3xl`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4 text-center">
                {value.title}
              </h3>
              <p className="text-sm text-gray-600 leading-relaxed text-center">
                {value.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
